import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-external-change-preview',
  templateUrl: './external-change-preview.component.html',
  styleUrls: ['./external-change-preview.component.css']
})
export class ExternalChangePreviewComponent implements OnInit {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ExternalChangePreviewComponentData,
    private _snackBarRef: MatSnackBarRef<ExternalChangePreviewComponent>
  ) { }

  close(){
    this._snackBarRef.dismiss();
  }

  ngOnInit(): void {
  }

}

export class ExternalChangePreviewComponentData {
  typeName: string;
  externalChange: { date: string, user: string, identifier: number, message: string };
}
